<template>
  <div class="index">
    <!-- 筛选 -->
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="120px">
        <div class="input-box">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码：">
              <el-input v-model="form.idCard" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right: 10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 按钮 -->
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" @click="openBox('create')" v-if="showBtn[3].isShow">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('pkhxx')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._z"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
      <el-button
        type="primary" icon="el-icon-document-remove" v-if="showBtn[5].isShow"
        v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)">导出数据</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="550" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          v-for="(o,i) in baseInfo" :key="i"
          :prop="o.key" :label="o.value" show-overflow-tooltip
          :width="o.type===3?'100px':''" align="center" :fixed="i<=7">
        </el-table-column>
      </el-table>
      <paging :pagesData="$data.paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="一户一档信息管理" :modal="false" width="1400px" center
      :visible.sync="centerDialogVisible" @close="close" :close-on-click-modal="false">
      <div>
        <!-- 贫困户信息 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">贫困户信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="户籍地址：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="自然村：">
                          <el-input style="width: 193px;" v-model="editForm.natureVillage"></el-input>
                        </el-form-item>
                        <el-form-item label="组：" prop="userSite">
                          <el-input style="width: 193px;" v-model="editForm.userSite"></el-input>
                        </el-form-item>
                        <el-form-item label="户编号：">
                          <el-input style="width: 193px;" v-model="editForm.residenceNo"></el-input>
                        </el-form-item>
                        <el-form-item label="人编号：">
                          <el-input style="width: 193px;" v-model="editForm.personNo"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：" prop="name">
                          <el-input style="width: 193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="证件号码：" prop="idCard">
                          <el-input style="width: 193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                          <el-input style="width: 193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="人数：">
                          <el-input style="width: 193px;" v-model="editForm.persons"></el-input>
                        </el-form-item>
                        <el-form-item label="与户主关系：">
                          <el-select size="mini" filterable v-model="editForm.relationShip" placeholder="请选择">
                            <el-option v-for="(o,i) in $public.yuhuzhuguanxi" :key="i" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="民族：">
                          <el-select size="mini" filterable v-model="editForm.nation" placeholder="请选择">
                            <el-option v-for="o in $public.nation" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="收入水平：">
                          <el-input style="width: 193px;" v-model="editForm.salaryLevel"></el-input>
                        </el-form-item>
                        <el-form-item label="家庭情况：">
                          <el-input style="width: 193px;" v-model="editForm.familyStatus"></el-input>
                        </el-form-item>
                        <el-form-item label="住房情况：">
                          <el-input style="width: 193px;" v-model="editForm.houseStatus"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="文化程度：">
                          <el-select size="mini" filterable v-model="editForm.education" placeholder="请选择">
                            <el-option v-for="item in $public.wenHuaCD" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="参加大病医疗：">
                          <el-select size="mini" filterable v-model="editForm.medical" placeholder="请选择">
                            <el-option v-for="item in $public.options" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="在校生状况：">
                          <el-select size="mini" filterable v-model="editForm.studentStatus" placeholder="请选择">
                            <el-option v-for="(item,index) in $public.zaixiaoshengzhuangkuang" :key="index" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="致贫原因：">
                          <el-select size="mini" filterable v-model="editForm.poorReason" placeholder="请选择">
                            <el-option v-for="item in $public.checkList2" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="健康状况：">
                          <el-select size="mini" filterable v-model="editForm.healthy" placeholder="请选择">
                            <el-option v-for="item in $public.jiankangzhuangtai" :key="item" :label="item" :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="劳动技能：">
                          <el-select size="mini" filterable v-model="editForm.laborSkill" placeholder="请选择">
                            <el-option v-for="item in $public.laoDongNL" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="务工状况：">
                          <el-select size="mini" v-model="editForm.workStatus" placeholder="请选择">
                            <el-option v-for="item in $public.wugongzhuangkuang" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="务工时间(月)：">
                            <el-input style="width: 193px;" v-model="editForm.workDuration"></el-input>
                        </el-form-item>
                        <el-form-item label="危房户：">
                          <el-select size="mini" v-model="editForm.dangerPoor" placeholder="请选择">
                            <el-option v-for="item in $public.options" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否解决饮用水安全：">
                          <el-select size="mini" v-model="editForm.safeWater" placeholder="请选择">
                            <el-option v-for="item in $public.options" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="人均纯收入：">
                            <el-input style="width: 193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="政治面貌：">
                          <el-select size="mini" v-model="editForm.dangerPoor" placeholder="请选择">
                            <el-option v-for="item in $public.zhengzhimianmao" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="户籍类型：">
                          <el-select size="mini" v-model="editForm.residenceType" placeholder="请选择">
                            <el-option v-for="item in $public.hujileixing" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="特殊困难群体人员：">
                          <el-select size="mini" v-model="editForm.type" placeholder="请选择">
                            <el-option v-for="item in $public.options" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item> -->
                        <el-form-item label="脱贫属性：">
                          <el-select size="mini" filterable v-model="editForm.lostPoorInfo" placeholder="请选择">
                            <el-option v-for="item in $public.tuopinzhuangtai" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫年度：">
                          <el-date-picker style="width: 193px;" v-model="editForm.lostPoorYear" value-format="yyyy" type="year" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="首次识别时间：">
                          <el-input style="width: 193px;" v-model="editForm.poorFirstDate"></el-input>
                        </el-form-item>
                        <el-form-item label="贫困人员识别时间：">
                          <el-input style="width: 193px;" v-model="editForm.poorInfoDate"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="返贫人员：">
                          <el-select size="mini" v-model="editForm.returnPoor" placeholder="请选择">
                            <el-option v-for="item in $public.options" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫方式：">
                          <el-select size="mini" filterable v-model="editForm.lostPoorStyle" placeholder="请选择">
                            <el-option v-for="item in $public.checkList3" :key="item.label" :label="item.label" :value="item.label"></el-option>
                          </el-select>
                        </el-form-item> -->
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
				<!-- 服务日志录入 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务日志录入</div>
            <div class="edit-right"  style="padding-top: 0">
              <div class="info-box">
                <div class="info-input">
                  <el-tabs type="border-card" v-model="activeName"  @tab-click="handleClick">
                    <el-tab-pane :label="item.value" :name="item.value" v-for="item in log" :key="item.key">
                      <div class="log">
                        <div>
                          <label for="desc">服务内容：</label>
                          <div id="desc">
                            <el-input type="textarea" v-model="serviceContent" :rows="3"></el-input>
                          </div>
                          <label for="res">服务结果：</label>
                          <div id="res">
                            <el-input type="textarea" v-model="serviceResult" :rows="3"></el-input>
                          </div>
                        </div>
                        <div>
                          <label for="img">上传图片：</label>
                          <div style="width: 100%;" id="img">
                            <el-upload
                              ref="uploadImg" list-type="picture-card" :class="{disabled:isMax}"
                              :action="uploadUrl" :file-list="fileList" :limit="3" 
                              :on-success="imgAdd" :on-error="error" :on-change="change"
                              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible" :modal="false">
                              <img width="100%" :src="imageUrl" alt="">
                            </el-dialog>
                          </div>
                          <div style="margin: 10px 10px 0 0;float:right;">
                            <el-button type="primary" v-show="!isCreate" @click="submitLog()">提交日志</el-button>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
				<!-- 服务记录查询 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务记录查询</div>
            <div class="edit-right"  style="padding-top: 0;flex: 0 0 95%;">
              <div class="info-box">
                <div class="info-input">
                  <el-table :data="logData" max-height="500" border style="width: 99.9%">
                    <el-table-column
                      v-for="o in $public.info" :key="o.key" show-overflow-tooltip
                      :prop="o.key" :label="o.value" align="center">
                    </el-table-column>
                    <el-table-column label="图片" type="expand">
                      <template slot-scope="props">
                        <div v-if="props.row.fileIds === ''?false:true">
                          <span v-for="(o,i) in props.row.fileIds" :key="i" style="margin-left: 10px">
                            <el-image  style="width: 100px;height: 100px" :src="o" :preview-src-list="props.row.fileIds"></el-image>
                          </span>
                        </div>
                        <div v-else>
                          <span>无详情图片</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <paging :pagesData="paging" @set_page_number='get_page'></paging>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api: '/user/poorInfo',
      form: {},
      type: '30',
      centerDialogVisible: false,
      tableData: [],
      selectRow: [],
      baseInfo: [
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'natureVillage',value:'自然村'},
        {key:'userSite',value:'组'},
        {key:'residenceNo',value:'户编号'},
        {key:'personNo',value:'人编号'},
        {key:'name',value:'姓名'},
        {key:'idCard',value:'证件号码'},
        {key:'persons',value:'人数'},
        {key:'relationShip',value:'与户主关系'},
        {key:'salaryLevel',value:'收入水平'},
        {key:'familyStatus',value:'家庭情况'},
        {key:'houseStatus',value:'住房情况'},
        {key:'nation',value:'民族'},
        {key:'education',value:'文化程度'},
        {key:'studentStatus',value:'在校生状况'},
        {key:'healthy',value:'健康状况'},
        {key:'laborSkill',value:'劳动技能'},
        {key:'workStatus',value:'务工状况'},
        {key:'workDuration',value:'务工时间（月）'},
        {key:'medical',value:'参加大病医疗'},
        {key:'lostPoorInfo',value:'脱贫属性'},
        {key:'lostPoorYear',value:'脱贫年度'},
        {key:'poorInfo',value:'贫困户属性'},
        {key:'poorReason',value:'致贫原因1'},
        {key:'dangerPoor',value:'危房户'},
        {key:'safeWater',value:'是否解决安全饮用水'},
        {key:'salary',value:'人均纯收入'},
        {key:'phone',value:'联系电话'},
        // {key:'politics',value:'政治面貌'},
        // {key:'residenceType',value:'户籍类型'},
        // {key:'difficultPerson',value:'特殊困难群体人员'},
        // {key:'lostPoorStyle',value:'脱贫方式'},
        // {key:'returnPoor',value:'返贫人员'},
        {key:'poorFirstDate',value:'首次识别时间'},
        {key:'poorInfoDate',value:'贫困人员识别时间'},
      ],
      options: [],
      rules:{
        name: [
          { required: true, message: '请输入单位名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          // { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        // phone: [
        //   { required: true, message: '请输入电话', trigger: 'blur' }
        // ],
      },
      isCreate: false,
      uploadUrl: `${this.$api.imgUrl}/user/img/upload`,
      log: [
        { value: '结对帮扶', key: 0 },
        { value: '信息采集', key: 1 },
        { value: '就业服务', key: 2 },
        { value: '培训服务', key: 3 },
        { value: '创业服务', key: 4 },
        { value: '维权服务', key: 5 },
        { value: '其它服务', key: 6 }
      ],
      imageUrl: '',
      logType: 1,
      activeName:'结对帮扶',
      logImg: [],
      serviceContent: '',
      serviceResult: '',
      fileList: [],
      isMax: false,
      dialogVisible: false,
      paging:{
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      logData: [],
      pageIndex_log: 1,
    }
  },
  methods:{
    handleSelectionChange(val) {
      console.log(val)
      this.selectRow = val
      val.length ? this.get_log_data(this.pageIndex_log, val[0].id) : ''
    },
    //分页
    get_page_number(pageNumer) {
      this.form.pageNumber = pageNumer
      this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid) => {
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res => {
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else return false
      })
    },
    //图片移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length < 3) { this.isMax = false }
    },
    //图片预览
    handlePictureCardPreview(file) {
      this.imageUrl = file.url
      this.dialogVisible = true
    },
    //图片状态改变时触发
    change(file,fileList) {
      if (fileList.length >= 3) { this.isMax = true }
    },
    //图片上传成功回调
    imgAdd(response,file, fileList) {
      this.fileList = fileList
      // this.$refs['uploadImg'].clearFiles()
    },
    //图片上传失败
    error(err, file, fileList) {
      this.$message.error('上传失败')
			this.isMax = fileList.length >= 3
    },
    //类型选择
    handleClick(tab, event) {
      this.logImg = []
      this.logType = parseInt(tab.index) + 1
    },
    //提交日志请求
    submitLog() {
      if (this.serviceContent === '') {
        return this.$message.info('请输入服务内容')
      } else if (this.serviceResult === '') {
        return this.$message.info('请输入服务结果')
      } else {
        this.fileList.forEach(o => {
          this.logImg.push(o.response.data)
        })
        let logData = {
          operateLogType: this.logType,
          targetId: this.selectRow[0].id,
          fileIds: this.logImg.join(','),
          serviceContent: this.serviceContent,
          serviceResult: this.serviceResult
        }
        this.$api.createLog(logData).then(res => {
          if (res.data.status === 0) {
            this.$message.success('提交日志成功！')
            this.$refs.uploadImg.forEach(o => { o.clearFiles() })
            this.serviceResult = this.serviceContent = ''
            this.get_log_data(this.pageIndex_log,this.selectRow[0].id)
          } else{
            this._status(res.data)
          }
        })
      }
    },
    //日志分页
    get_page(pageNumer) {
      this.get_log_data(pageNumer, this.selectRow[0].id)
    },
    //对象日志记录查询
    get_log_data(page, id) {
      let request = { pageNumber: page, targetId: id }
      this.$api.getTargetLog(request).then(res => {
        if (res.data.status === 0) {
          this.paging.total = res.data.size
          this.paging.pageSize = res.data.pageSize
          this.logData = JSON.parse(res.data.data)
          this.logData.forEach(o => {
            o.operateLogType = this.$public.type[o.operateLogType - 1]
            if (o.fileIds === '') {} else {
              o.fileIds = o.fileIds.split(',')
              o.fileIds.forEach((item,index) => {
                o.fileIds[index] = this.$api.imgUrl+ '/user/img/' +item
              })
            }
          })
        } else {
          this._status(res.data)
        }
      })
    },
  },
  created() {
    this.isShowBtn("PoorInfo")//控制操作按钮的显示与隐藏
    this.getArea({ value: { areaId: 0 }, key: 0 })
  },
  //路由守卫结对帮扶跳到这里
  beforeRouteEnter:(to,from,next) => {
    next(vm => {
      // console.log(vm.$route.params.info)
      if (vm.$route.params.info === undefined) {
      } else {
        let Id = [vm.$route.params.info[0].provinceId,vm.$route.params.info[0].cityId,
        vm.$route.params.info[0].countyId,vm.$route.params.info[0].townId,vm.$route.params.info[0].villageId]
        let placeId = Id.filter(o => o)
        let data = {
          areaId: placeId[placeId.length-1],
          idCard: vm.$route.params.info[0].idCard
        }
        // vm.Filter_file({api:vm.api,data:data,callback:_d => vm.tableData = _d })
        vm.$api.getData(vm.api, data).then(res => {
          if (res.data.status === 0) {
            vm.tableData = JSON.parse(res.data.data)
            if (JSON.parse(res.data.data).length === 0) {
              vm.$message.info('无相关信息')
            }
            vm.paging_data.total = res.data.size
            vm.paging_data.pageSize = res.data.pageSize

            vm.isCreate = false
            vm.editForm = JSON.parse(res.data.data)[0]
            vm.setPlace(vm.editForm)
            vm.centerDialogVisible = true  
          } else{
            this._status(res.data)
          }
        })
      }
    })
  }
}
</script>

<style>
.index-header{overflow-x: auto;}
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.el-textarea .el-textarea__inner{resize: none;}
.log{
  display: flex;
  flex-direction: row;
}
.log>div{
  flex: 1 1 40%;
  margin-left: 20px;
}
.log .disabled .el-upload--picture-card{
  display: none
}
.info-input .el-tabs--border-card>.el-tabs__content{
  padding: 10px 0 10px 0!important;
}  
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 178px;
  display: block;
}
</style>